
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqs0CKtWKp9RPWq01nqeA5n6nDsbhxkmyjWku68Md8MJqIMeta } from "/opt/buildhome/repo/pages/faqs.vue?macro=true";
import { default as indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta } from "/opt/buildhome/repo/pages/index.vue?macro=true";
import { default as usersDdKPYX7w1ohR5mdXAQEOOek61BW6bWXppqUQM2l77ncMeta } from "/opt/buildhome/repo/pages/users.vue?macro=true";
import { default as eventsolhiYTdAs3OdxlS9A7weFHvOg_uQSmkgm67fKyTXpNoMeta } from "/opt/buildhome/repo/pages/events.vue?macro=true";
import { default as sign_inFFyEGpE7oqBl66UUOrU5KCGZKsGZ8fc1vpA5h_45LpX_kMeta } from "/opt/buildhome/repo/pages/sign_in.vue?macro=true";
import { default as productsY2XB_454cDKLta72k90vx8ISbqhUFoUiYZTBg44pjiRE4Meta } from "/opt/buildhome/repo/pages/products.vue?macro=true";
import { default as newlghIR4aUi4hw8oI0Zk39xtorlmcp9VTJ9VOTLN6oxz4Meta } from "/opt/buildhome/repo/pages/legal/new.vue?macro=true";
import { default as postsuQnOllF0vg_45_45QXjWm_45xfUJlCQrIr6cQjS769EK9rwWgMeta } from "/opt/buildhome/repo/pages/blog/posts.vue?macro=true";
import { default as index9pZx2FXtc_45dA_45Sb5lmZZi0cZNoM7qAFapRcJnrZyUkgMeta } from "/opt/buildhome/repo/pages/legal/index.vue?macro=true";
import { default as newo1IuT9FGWtVfRT1zp4vJwDkiQcG_457F7qQtnV7EF4AEUMeta } from "/opt/buildhome/repo/pages/blog/post/new.vue?macro=true";
import { default as categoriesjQ_4589HXGJLnUENm0GXwyn2phUFG8lbfSDRWVfJ5JXFAMeta } from "/opt/buildhome/repo/pages/blog/categories.vue?macro=true";
import { default as _91id_93kmYTwQab6Qp5XyGuv74FkGs2IaMp7ElqsFFQiWfa2doMeta } from "/opt/buildhome/repo/pages/legal/edit/[id].vue?macro=true";
import { default as _91id_93dGG6Z8wpF9yXp8fi5uBPGYGe0SBmzwErNNis6T0JALUMeta } from "/opt/buildhome/repo/pages/legal/show/[id].vue?macro=true";
import { default as profilew5uUefDJpU_45NO0wEWdV1LJI8ay_Fc5lJ5R9m_45E3lcbIMeta } from "/opt/buildhome/repo/pages/settings/profile.vue?macro=true";
import { default as sectionsEUmchEzgG1BchrVnsL6EUxr7qp6WQvSOvyzl6IWSgcYMeta } from "/opt/buildhome/repo/pages/support/sections.vue?macro=true";
import { default as password6X2LEpv4B2NveboRVupd2PLqYv0402zLtZ7GuD4g4OsMeta } from "/opt/buildhome/repo/pages/settings/password.vue?macro=true";
import { default as _91id_93r_45h_45NLEwi67dRTYXsq94Nhd_450cOXGkpQzl9LpQCu5HwMeta } from "/opt/buildhome/repo/pages/blog/post/edit/[id].vue?macro=true";
import { default as _91id_93aaTynLxeOzVztqsFe9s1GioWBWi6E_uzt2dPJpv3DvkMeta } from "/opt/buildhome/repo/pages/blog/post/show/[id].vue?macro=true";
import { default as preferencesn1J_45UUVwBaGXYuE3ZlRFuVLOR2ZBKwVtg7HpfalurS4Meta } from "/opt/buildhome/repo/pages/settings/preferences.vue?macro=true";
import { default as newTSkmEjI53HZs8QwgorK_45ByxhRnZ88SYntfHSL1ChkQ0Meta } from "/opt/buildhome/repo/pages/support/articles/new.vue?macro=true";
import { default as indexTl_kgKo8_45o22HJA_xNaU3sMr2oONcp76c0UsI8CF8_sMeta } from "/opt/buildhome/repo/pages/support/articles/index.vue?macro=true";
import { default as _91id_93ze3AbjsDZDtBzqtwQ_bX8GMWU3km8I2iq8LPLFlNk_450Meta } from "/opt/buildhome/repo/pages/support/articles/edit/[id].vue?macro=true";
import { default as _91id_93wm_Dh5KrAuDY5mi69tWqgmjnzEdS0ZtiDLeLfctDvIUMeta } from "/opt/buildhome/repo/pages/support/articles/show/[id].vue?macro=true";
export default [
  {
    name: "faqs___br",
    path: "/faqs",
    meta: faqs0CKtWKp9RPWq01nqeA5n6nDsbhxkmyjWku68Md8MJqIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/faqs.vue")
  },
  {
    name: "index___br",
    path: "/",
    meta: indexQLbd_45_VEGEymTy61om4OM78JfxLHuFgCIu_qxD7KdRoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/index.vue")
  },
  {
    name: "users___br",
    path: "/users",
    meta: usersDdKPYX7w1ohR5mdXAQEOOek61BW6bWXppqUQM2l77ncMeta || {},
    component: () => import("/opt/buildhome/repo/pages/users.vue")
  },
  {
    name: "events___br",
    path: "/events",
    meta: eventsolhiYTdAs3OdxlS9A7weFHvOg_uQSmkgm67fKyTXpNoMeta || {},
    component: () => import("/opt/buildhome/repo/pages/events.vue")
  },
  {
    name: "sign_in___br",
    path: "/sign_in",
    meta: sign_inFFyEGpE7oqBl66UUOrU5KCGZKsGZ8fc1vpA5h_45LpX_kMeta || {},
    component: () => import("/opt/buildhome/repo/pages/sign_in.vue")
  },
  {
    name: "products___br",
    path: "/products",
    meta: productsY2XB_454cDKLta72k90vx8ISbqhUFoUiYZTBg44pjiRE4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/products.vue")
  },
  {
    name: "legal-new___br",
    path: "/legal/new",
    meta: newlghIR4aUi4hw8oI0Zk39xtorlmcp9VTJ9VOTLN6oxz4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/legal/new.vue")
  },
  {
    name: "blog-posts___br",
    path: "/blog/posts",
    meta: postsuQnOllF0vg_45_45QXjWm_45xfUJlCQrIr6cQjS769EK9rwWgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/posts.vue")
  },
  {
    name: "legal___br",
    path: "/legal",
    meta: index9pZx2FXtc_45dA_45Sb5lmZZi0cZNoM7qAFapRcJnrZyUkgMeta || {},
    component: () => import("/opt/buildhome/repo/pages/legal/index.vue")
  },
  {
    name: "blog-post-new___br",
    path: "/blog/post/new",
    meta: newo1IuT9FGWtVfRT1zp4vJwDkiQcG_457F7qQtnV7EF4AEUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/post/new.vue")
  },
  {
    name: "blog-categories___br",
    path: "/blog/categories",
    meta: categoriesjQ_4589HXGJLnUENm0GXwyn2phUFG8lbfSDRWVfJ5JXFAMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/categories.vue")
  },
  {
    name: "legal-edit-id___br",
    path: "/legal/edit/:id()",
    meta: _91id_93kmYTwQab6Qp5XyGuv74FkGs2IaMp7ElqsFFQiWfa2doMeta || {},
    component: () => import("/opt/buildhome/repo/pages/legal/edit/[id].vue")
  },
  {
    name: "legal-show-id___br",
    path: "/legal/show/:id()",
    meta: _91id_93dGG6Z8wpF9yXp8fi5uBPGYGe0SBmzwErNNis6T0JALUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/legal/show/[id].vue")
  },
  {
    name: "settings-profile___br",
    path: "/settings/profile",
    meta: profilew5uUefDJpU_45NO0wEWdV1LJI8ay_Fc5lJ5R9m_45E3lcbIMeta || {},
    component: () => import("/opt/buildhome/repo/pages/settings/profile.vue")
  },
  {
    name: "support-sections___br",
    path: "/support/sections",
    meta: sectionsEUmchEzgG1BchrVnsL6EUxr7qp6WQvSOvyzl6IWSgcYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/support/sections.vue")
  },
  {
    name: "settings-password___br",
    path: "/settings/password",
    meta: password6X2LEpv4B2NveboRVupd2PLqYv0402zLtZ7GuD4g4OsMeta || {},
    component: () => import("/opt/buildhome/repo/pages/settings/password.vue")
  },
  {
    name: "blog-post-edit-id___br",
    path: "/blog/post/edit/:id()",
    meta: _91id_93r_45h_45NLEwi67dRTYXsq94Nhd_450cOXGkpQzl9LpQCu5HwMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/post/edit/[id].vue")
  },
  {
    name: "blog-post-show-id___br",
    path: "/blog/post/show/:id()",
    meta: _91id_93aaTynLxeOzVztqsFe9s1GioWBWi6E_uzt2dPJpv3DvkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/blog/post/show/[id].vue")
  },
  {
    name: "settings-preferences___br",
    path: "/settings/preferences",
    meta: preferencesn1J_45UUVwBaGXYuE3ZlRFuVLOR2ZBKwVtg7HpfalurS4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/settings/preferences.vue")
  },
  {
    name: "support-articles-new___br",
    path: "/support/articles/new",
    meta: newTSkmEjI53HZs8QwgorK_45ByxhRnZ88SYntfHSL1ChkQ0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/support/articles/new.vue")
  },
  {
    name: "support-articles___br",
    path: "/support/articles",
    meta: indexTl_kgKo8_45o22HJA_xNaU3sMr2oONcp76c0UsI8CF8_sMeta || {},
    component: () => import("/opt/buildhome/repo/pages/support/articles/index.vue")
  },
  {
    name: "support-articles-edit-id___br",
    path: "/support/articles/edit/:id()",
    meta: _91id_93ze3AbjsDZDtBzqtwQ_bX8GMWU3km8I2iq8LPLFlNk_450Meta || {},
    component: () => import("/opt/buildhome/repo/pages/support/articles/edit/[id].vue")
  },
  {
    name: "support-articles-show-id___br",
    path: "/support/articles/show/:id()",
    meta: _91id_93wm_Dh5KrAuDY5mi69tWqgmjnzEdS0ZtiDLeLfctDvIUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/support/articles/show/[id].vue")
  }
]